/** Marks the global transaction toast so overlays can tell it apart from the page. */
export const TRANSACTION_STATUS_ATTRIBUTE = 'data-transaction-status';

/** True when an event target sits inside the transaction toast. */
export const isInsideTransactionStatus = (target: EventTarget | null) =>
  target instanceof Element && target.closest(`[${TRANSACTION_STATUS_ATTRIBUTE}]`) !== null;

type OutsideEvent = { target: EventTarget | null; preventDefault: () => void };

/**
 * onInteractOutside for Radix Dialog/Sheet and vaul Drawer content: the toast
 * floats above every overlay (outside its content), so tapping it must not
 * count as an outside interaction and close the overlay underneath.
 */
export const keepOpenOnTransactionStatus = (e: OutsideEvent) => {
  if (isInsideTransactionStatus(e.target)) e.preventDefault();
};
